<template>
  <div class="levelling-container">
    <div id="file-drag-drop" v-if="!showTable">
      <form ref="fileform" class="dragzone">
        <span class="drop-files">Drop the levelling file here</span>
        <p>{{result}}</p>
      </form>
      <v-progress-circular v-if="showProgressSpinner"
        :width="3"
        color="red"
        indeterminate
      ></v-progress-circular>
    </div>
    <div>
      <div v-if="showTable">
        <v-btn @click="xlsxExport" class="ma-2" color="success">
          Download XLSX
          <v-icon right>cloud_download</v-icon>
        </v-btn>
        <v-btn @click="clearData" class="ma-2" color="info">
          Clear
          <v-icon right>autorenew</v-icon>
        </v-btn>        
      </div>
      <v-data-table 
        v-if="showTable"
        :headers="headers"
        :items="leveldata"
        :items-per-page="10"
        class="obstable"
      >
        <template v-slot:item.name="props">
          <v-autocomplete
            :class="props.item.class"
            v-model="props.item.name"
            :items="sensors"
            items-per-page=50
            :label="tableLabel(props.item)"
            v-on:change="changeSensor(props.item)"
          ></v-autocomplete>
        </template>    
      </v-data-table>
      <v-snackbar v-model="snackbar">
        {{ snackbartext }}
        <v-btn color="pink" text @click="snackbar = false" >
          Close
        </v-btn>
      </v-snackbar>      
    </div>
  </div>
</template>

<script>
import UsersApi from '@/services/UsersApi';
import XLSX from 'xlsx';
export default {
  /*
    Variables used by the drag and drop component
  */
  data(){
    return {
      dragAndDropCapable: false,
      files: [],
      result: '',      
      showTable: false,
      showProgressSpinner: false,
      leveldata: [],
      sensors: [],
      snackbar: false,
      snackbartext: '',
      exportFileName: '',
      pagination: {
        page: 1,
        rowsPerPage: 50,
        rowsPerPageItems: [50, 100, 150, 200, 250]
      },
      headers: [
        { text: 'Date Time', value: 'date', align: 'center', sortable: false, class:'caption' },
        { text: 'Name', value: 'name', align: 'center', sortable: false, class:'caption' },
        { text: 'Level', value: 'level', align: 'center', sortable: false, class:'caption' },
        { text: 'Last Level', value: 'lastElevation', align: 'center', sortable: false, class:'caption' },
        { text: 'Last Obs. Date', value: 'lastObservation', align: 'center', sortable: false, class:'caption' },
        { text: 'Last Diff.', value: 'lastDifference', align: 'center', sortable: false, class:'caption' },
      ],
    }
  },
  mounted(){
    this.dragAndDropCapable = this.determineDragAndDropCapable();
    if( this.dragAndDropCapable ){
      ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach( function( evt ) {
        this.$refs.fileform.addEventListener(evt, function(e){
          e.preventDefault();
          e.stopPropagation();
        }.bind(this), false);
      }.bind(this));

      this.$refs.fileform.addEventListener('drop', function(e){
        if (e.dataTransfer.files.length === 1) {
          let re = /(?:\.([^.]+))?$/;
          let ext = re.exec(e.dataTransfer.files[0].name)
          if (ext[0] === '.csv') {
            for( let i = 0; i < e.dataTransfer.files.length; i++ ){
              this.files.push( e.dataTransfer.files[i] );
            }
            this.submitFiles();
          } else {
            this.snackbartext = 'Only a csv file will be processed'
            this.snackbar = true
          }
        } else {
          this.snackbartext = 'Only one file can be uploaded at a time'
          this.snackbar = true
        }
      }.bind(this));
    }
  },

  methods: {
    determineDragAndDropCapable(){
      let div = document.createElement('div');
      return ( ( 'draggable' in div )
              || ( 'ondragstart' in div && 'ondrop' in div ) )
              && 'FormData' in window
              && 'FileReader' in window;
    },
    submitFiles(){
      let formData = new FormData();
      this.result = 'Fetching T4D data'
      this.showProgressSpinner = true
      formData.append('file', this.files[0]);
      UsersApi.uploadLevellingData(formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then((response)=>{
        this.result = response.data.message
        this.leveldata = response.data.data
        this.sensors = response.data.sensors
        this.exportFileName = response.data.filename.replace('.csv','.xlsx')
        this.uploadPercentage = 0
        this.showProgressSpinner = false
        this.showTable = true
      }).catch((err)=>{
        if (err.response.status === 403) {
          this.$store.dispatch('setToken', null)
          this.$store.dispatch('setUser', null)          
          this.result = err.response.data.error +'\n Redirecting to login';
          setTimeout( () => { 
            this.$router.push({ path: 'signin'})
          }, 5000);
        }
        this.uploadPercentage = 0
        this.showProgressSpinner = false
        console.log(err);
      })
    },
    async changeSensor(data){
      const result = this.sensors.filter(sensor => sensor === data.name);
      if (result.length > 0) {
        for (let ld of this.leveldata) {
          if (ld.class === data.class 
              && ld.name === data.name
              && ld.date === data.date
              && ld.level === data.level) {
            ld.class = 'lu-matched';
          }
        }
      }
      const response = await UsersApi.setLevellingMatch({ t4d_name: data.name, tbc_name: data.origin })
      console.log(response.data)
    },
    tableLabel(data){
      if(data.class === 'lu-required') {
        return  data.name + ' (' +
                data.class.replace('lu-','').charAt(0).toUpperCase() + 
                data.class.replace('lu-','').substr(1).toLowerCase() +
                ')'
      }
      return data.origin +' (' +
             data.class.replace('lu-','').charAt(0).toUpperCase() + 
             data.class.replace('lu-','').substr(1).toLowerCase() +
             ')'
    },
    xlsxExport(){
      let wb = XLSX.utils.book_new();
      let xlsxContent = []
      xlsxContent.push(["Observation Date","Sensor","Elevation (m)"])
      for (let ld of this.leveldata) {
        xlsxContent.push([
          ld.date.replace(/(\r\n|\n|\r)/gm, ""), 
          ld.name, 
          ld.level
        ])
      }
      XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(xlsxContent), "Data (STID=25)");
      XLSX.writeFile(wb, this.exportFileName);
    },
    csvExport() {
      let csvContent = "data:text/csv;charset=utf-8,";
      for (let ld of this.leveldata) {
        csvContent += ld.date + ',' + ld.name + ',' + ld.level + '\n'
      }
      csvContent = csvContent.replace(/(^\[)|(\]$)/gm, "")
      const data = encodeURI(csvContent)
      const link = document.createElement("a")
      link.setAttribute("href", data)
      link.setAttribute("download", this.exportFileName)
      link.click();
    },
    clearData() {
      this.showTable = false
      this.leveldata = []
      this.sensors = []
      this.files = []
      this.result = ''
      this.$router.go()
    }
  }
}
</script>

<style>
  .dragzone{
    display: block;
    height: 200px;
    width: 200px;
    background: #ccc;
    margin: auto;
    margin-top: 40px;
    text-align: center;
    line-height: 200px;
    border-radius: 4px;
  }

  progress{
    width: 400px;
    margin: auto;
    display: block;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .levelling-container{
    width: 60%;
    margin: 0 auto;
    padding: 20px;
  }

  .lu-matched {
    background-color: #DCEDC8;     
  }

  .lu-required {
    background-color: #FFCCBC;      
  }

  .v-progress-circular {
    margin: 1rem;
  }

  .obstable {
    margin-bottom:66px
  }  

  .obstable td {
    font-size: 11px !important;
  }  

  .obstable input {
    font-size: 12px !important;
  }

</style>